import React from 'react';
import ContentUpload from 'components/content-upload';
import { useExploreContext } from 'contexts/explore.context';
import PhonePreview from 'components/phone-preview';

const VideoContentUpload = () => {
  const { formState, setFormState, contentUrl } = useExploreContext();
  return (
    <section className='flex items-start'>
      <div className='shrink p-8 w-full sm:mr-[275px] mr-0 max-w-[700px]'>
        <ContentUpload contentType='video' formState={formState} setFormState={setFormState} />
      </div>

      <div className='w-[275px] shrink-0 border-l border-gray-1 bg-gray-27 fixed h-full overflow-y-auto right-0 top-[60px] hidden sm:block'>
        <PhonePreview
          promoPost={formState.promoPost}
          caption={formState.caption}
          urls={contentUrl}
          type='video'
        />
      </div>
    </section>
  );
};
export default VideoContentUpload;
